import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import { IoClose } from 'react-icons/io5';
import { Fonts, Palette } from '../../components/utils';

 // Shared chat sidebar header.
const ChatPanelHeader = ({ title, subtitle, compact = false, onBack, onClose }) => {
  const { t } = useTranslation();

  return (
    <Header>
      {onBack && (
        <IconButton type="button" onClick={onBack} aria-label={t('Back')} $tone="dark">
          <HiOutlineArrowLeft size={20} />
        </IconButton>
      )}
      {compact ? (
        <Identity>
          <CompactTitle title={title}>{title}</CompactTitle>
          {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        </Identity>
      ) : (
        <Title>{title}</Title>
      )}
      {onClose && (
        <IconButton type="button" onClick={onClose} aria-label={t('Close')} $tone="muted" $end>
          <IoClose size={20} />
        </IconButton>
      )}
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
  height: 84px;
  padding: 16px 20px;
  background: ${Palette.WHITE};
  border-bottom: 1px solid #d5d5d5;
  flex-shrink: 0;
`;

const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ $tone }) => ($tone === 'dark' ? Palette.BLACK : Palette.BLACK_50)};
  cursor: pointer;
  flex-shrink: 0;
  ${({ $end }) => ($end ? 'margin-left: auto;' : '')}

  &:hover {
    color: ${Palette.BLACK};
  }

  &:focus {
    outline: none;
  }
`;

const Title = styled.h2`
  margin: 0;
  flex: 1;
  min-width: 0;
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
`;

const Identity = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

const CompactTitle = styled.span`
  color: ${Palette.BLACK};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Subtitle = styled.span`
  color: ${Palette.CONTENT_TERTIARY};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default ChatPanelHeader;
